import {Formik, Form, Field, ErrorMessage} from "formik";
import "./Login.css";
import * as Yup from 'yup';
import axios from "axios";
import { componentDidMount, AuthContext } from '../helpers/AuthContext';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";


function Login () {

    useEffect(()=>{
        componentDidMount("Login");
    }, [])
    
    const { setAuthState } = useContext(AuthContext);

    const initialValues = {
        UserName: "",
        Password: ""
    };

    const validationSchema = Yup.object().shape({
        UserName: Yup.string().email("Debe ingresar un e-mail valido").required("Se requiere un nombre de usuario"),
        Password: Yup.string().required("Se requiere password para ingresar")
    })
    
    const valuesToApi = {
        "grant_type": "password",
        "client_id": "1_3lc61sd1pjokooo80oswgcwo8oocko0gcos4oc4gs8sc04ogk0",
        "client_secret": "q95t0tu36qs48cgsk0gwo440w8ksswgg0os4ow8gog080owgs",
        "username": "",
        "password": ""
    }

    let navigate = useNavigate();

    const onsubmit = (data) =>{
        valuesToApi.username = data.UserName;
        valuesToApi.password = data.Password;
        const jsonValues = JSON.stringify(valuesToApi);
        sessionStorage.setItem("userName", data.UserName);
        
        axios.post('http://api.coexca.cl/oauth/v2/token', jsonValues, {
            headers: { 'Content-Type' : 'application/json' }
        }).then((response)=>{
            sessionStorage.setItem("accessToken", response.data.access_token);
            
            setAuthState(true);

            if(sessionStorage.getItem("accessToken")){
                navigate(`/`);
            }else{
                setAuthState(true);
            }
        }).catch((error)=>{
            alert("Datos ingresados no validos");
        });
    };

    return (
        <div className="loginPage">
            <Formik initialValues={initialValues} onSubmit={onsubmit} validationSchema={validationSchema} >
                <Form className="formContainer">
                    <label >Username:</label>
                    <Field id="inputUserName" name="UserName" placeholder="correo@gmail.com" type="e-mail"/>
                    <ErrorMessage name="UserName" component="span"/>
                    <label>Password:</label>
                    <Field id="inputPassword" name="Password" placeholder="Password" type="password"/>
                    <ErrorMessage name="Password" component="span"/>

                    <button type="submit" href="/">Login</button>
                </Form>
            </Formik>
        </div>
    )
}

export default Login
